import React from 'react';
import { Route } from 'react-router-dom';
import TicketsPage from './TicketsPage';

export const routes = [<Route key="0" path="/tickets" component={TicketsPage} />];

export const navigation = { name: 'tickets', link: '/tickets', icon: 'Tickets', parent: 'Members' };
